import { gallery, galleryCategories } from "../data/gallery";
import { GalleryGrid } from "../components/GalleryGrid";
import { Reveal } from "../components/Reveal";
import { useTitle } from "../hooks/useTitle";

export default function GalleryPage() {
  useTitle("Gallery | HairByYaya");

  return (
    <div className="px-5 pb-24 pt-28 md:pt-36" data-testid="gallery-page">
      <div className="mx-auto max-w-7xl">
        <Reveal className="mb-12">
          <p className="font-script text-3xl text-hotpink">the proof</p>
          <h1 className="mt-2 font-serif text-4xl md:text-6xl">The Gallery</h1>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/55">
            A portfolio of parts, patterns, and protective styles. Tap any look
            to view it up close — or book it for yourself.
          </p>
        </Reveal>

        <GalleryGrid items={gallery} categories={galleryCategories} />

        <p className="mt-10 text-center text-[11px] text-white/30">
          Placeholder photography — Yaya's original portfolio images will
          replace these after owner approval.
        </p>
      </div>
    </div>
  );
}

